import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPunkts } from '@cabinet-packages/redux';

/**
 * Хук для завантаження даних пунктів забору
 * @returns {Object} { punkts, clientLocation, loading }
 */
const useCollectionPointsData = () => {
    const dispatch = useDispatch();
    const { punkts, clientLocation } = useSelector(store => store.collectionPoints);

    useEffect(() => {
        dispatch(getPunkts());
    }, [dispatch]);

    return {
        punkts: punkts || [],
        clientLocation,
        loading: !punkts,
    };
};

export default useCollectionPointsData;
